import { render, staticRenderFns } from "./register.vue?vue&type=template&id=64641824&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style1 from "./register.vue?vue&type=style&index=1&id=64641824&prod&lang=less&scoped=true"
import style2 from "./register.vue?vue&type=style&index=2&id=64641824&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64641824",
  null
  
)

export default component.exports